/*
 * Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { createSlice } from "@reduxjs/toolkit";
import { organizationState } from "./organization.state";

const organizationSlice = createSlice({
    
    name: "organization",

    initialState: organizationState,

    reducers: {
        setOrganizationItem (state, action) {
            const organization = action.payload;
            const guid = organization.guid;
            state.current = organization;
            state.current_guid = guid;
        },

        removeOrganizationItem (state) {
            state.current = undefined;
            state.current_guid = undefined;
        },
    },
});

export const organizationReducer = organizationSlice.reducer;

export const {
    setOrganizationItem,
    removeOrganizationItem
} = organizationSlice.actions;
